import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Row, Column } from "react-foundation";

import { getAdditionalStyles } from "actions";
import ThemeButton from "../../components/ThemeButton";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";
import FormWrapper from "../FormWrapper";
import SimpleFormField from "../../components/SimpleFormField";
import { withRouter } from "react-router-dom";
import {sendAdditionalQuoteRequest} from '../../actions/enquiry';


class ContactForm extends Component {

    constructor(props) {
        super(props);
        this.state = { submitting: false };
    }

    onSubmit(values) {
        if (this.state.submitting) return;

        this.setState({ submitting: true });

        this.props.sendAdditionalQuoteRequest({emailFormValues: values, item: this.props.additionalItem}, () =>{
            this.props.history.push("/Thanks");
        });
    }
    

    render() {
        const { additionalItem, previousPage } = this.props;

        return (
            <form onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))} className="ContactForm">
                <FormHeader title={additionalItem.name} subtitle={"Please fill in your details and a quote will be emailed to you"} />
                <SeparatingLine />
                <FormWrapper>
                <Row collapseOnSmall uncollapseOnMedium className="contact-form" >
                    <Column large={6} className="preview-container" hideOnlyFor="small">
                        <img src={additionalItem.externalImageUrl} className="image-pane" alt="" />
                    </Column>
                    <Column
                        large={6}
                        className="swatch-selector-container">
                            <Row>
                                <Column
                                    large={8}
                                    centerOnSmall
                                    className="customer-info-field"
                                >
                                    <Field name="name" component={SimpleFormField} autoFocus={true}>
                                        Full name:
                                    </Field>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    large={8}
                                    centerOnSmall
                                    className="customer-info-field"
                                >
                                    <Field name="telephone" component={SimpleFormField}>
                                        Telephone:
                                    </Field>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    large={8}
                                    centerOnSmall
                                    className="customer-info-field"
                                >
                                    <Field name="email" component={SimpleFormField}>
                                        Email:
                                    </Field>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    large={8}
                                    centerOnSmall
                                    className="customer-info-field"
                                >
                                    <Field name="postcode" component={SimpleFormField}>
                                        Postcode:
                                    </Field>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    large={8}
                                    centerOnSmall
                                    className="customer-info-field"
                                >
                                    <p
                                        style={{
                                            fontSize: "0.7em",
                                            marginTop: 5,
                                            marginBottom: 5
                                        }}
                                    >
                                        We’ll only use this information to allow your chosen
                                        approved supplier to get in touch with you, and allow you to
                                        access your quote again in the future.
                                    </p>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    large={8}
                                    centerOnSmall
                                    className="customer-info-field"
                                >
                                    <Field name="TandC" type="checkbox" component={SimpleFormField}>
                                        {"I agree with QuoteBuilder's "}
                                        <a
                                            href="http://www.doubleglazingnetwork.com/terms-conditions/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Terms and Conditions
                                        </a>
                                    </Field>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    large={8}
                                    centerOnSmall
                                    className="customer-info-field"
                                >
                                    <Field
                                        name="consentCommunication"
                                        type="checkbox"
                                        component={SimpleFormField}
                                    >
                                        I agree for my chosen suppliers to contact me.
                                    </Field>
                                </Column>
                            </Row>
                    </Column>
                </Row>
                </FormWrapper>
                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Submit</ThemeButton>
                </div>
            </form>   
        );
    }
}

const validate = (values) => {
    let errors = {};
    if (!values.name) errors.name = "Required";
    if (!values.email) errors.email = "Required";
    if (!values.telephone) errors.telephone = "Required";
    if (!values.postcode) errors.postcode = "Required";

    if (!values.TandC) errors.TandC = "Required";
    if (!values.consentCommunication) errors.consentCommunication = "Required";

    return errors;
};

const mapStateToProps = state => {
    let additionalItem = state.Additional.Types.filter(v => v.id === state.PreviousSelection.AdditionalTypeId)[0];
    return {
        additionalItem: additionalItem,
        additionalTypeId: state.PreviousSelection.AdditionalTypeId
    };
};

export default withRouter(connect(mapStateToProps, { getAdditionalStyles, sendAdditionalQuoteRequest })(
    reduxForm({
        form: "contactForm",
        validate
    })(ContactForm))
);



// WEBPACK FOOTER //
// ./src/containers/AdditionalForm/ContactForm.js